var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.1665,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 12.375C22.1165 12.375 23.2915 13.55 23.2915 15C23.2915 16.45 22.1165 17.625 20.6665 17.625C19.2165 17.625 18.0415 16.45 18.0415 15C18.0415 13.55 19.2165 12.375 20.6665 12.375ZM20.6665 23.625C24.379 23.625 28.2915 25.45 28.2915 26.25V27.625H13.0415V26.25C13.0415 25.45 16.954 23.625 20.6665 23.625ZM20.6665 10C17.904 10 15.6665 12.2375 15.6665 15C15.6665 17.7625 17.904 20 20.6665 20C23.429 20 25.6665 17.7625 25.6665 15C25.6665 12.2375 23.429 10 20.6665 10ZM20.6665 21.25C17.329 21.25 10.6665 22.925 10.6665 26.25V30H30.6665V26.25C30.6665 22.925 24.004 21.25 20.6665 21.25Z",
    fill: "#B8B8B8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.1665,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#F1F2F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfile);
export default __webpack_public_path__ + "static/media/default-profile.a6f2c35618de4717c3f90003e705890e.svg";
export { ForwardRef as ReactComponent };